import GovernmentIcon from '@images/header/icons/government.svg'
import Cleaning from '@images/header/icons/Cleaning.svg'
import HomeServicesIcon from '@images/header/icons/homeServices.svg'
import AutomotiveServices from '@images/header/icons/Automotive.svg'
import PersonalServices from '@images/header/icons/Personal.svg'
import Salons from '@images/header/icons/salons.svg'
import Barbershop from '@images/header/icons/barbershop.svg'
import Healthcare from '@images/header/icons/healthcare.svg'
import Dental from '@images/header/icons/dental.svg'
import Coaching from '@images/header/icons/Coaching.svg'
import Education from '@images/header/icons/education.svg'
import Sports from '@images/header/icons/fitness.svg'
import Blog from '@images/header/icons/blog.svg'
import Docs from '@images/header/icons/docs.svg'
import Agency from '@images/header/icons/agency.svg'

const platformFeatures = [
  {
    name: 'Features overview',
    items: [
      {
        title: 'All Features',
        description: 'Keep your business running 24/7 with Trafft features and integrations',
        link: '/features'
      },
      {
        title: 'Features and Plans Comparison',
        description: 'Check the detailed comparison of Trafft plans',
        link: '/plans-comparison/'
      }
    ]
  },
  {
    name: 'Business and Client Management',
    items: [
      {
        title: 'Business Dashboard',
        description: 'Gain a comprehensive view of your business performance',
        link: '/features/business-dashboard/'
      },
      {
        title: 'Business Processes Automation',
        description: 'Automate every single aspect of your business with one tool',
        link: '/features/business-process-automation/'
      },
      {
        title: 'Employee Management',
        description: 'Organize everything related to employees',
        link: '/features/employee-management/'
      },
      {
        title: 'Customer Management',
        description: 'Gain more returning customers',
        link: '/features/customer-management/'
      },
      {
        title: 'Self-Serve Customer Booking',
        description: 'Let your customers book, cancel or reschedule appointments 24/7',
        link: '/features/self-serve-customer-booking/'
      }
    ]
  },
  {
    name: 'Booking and Scheduling System',
    items: [
      {
        title: 'Booking Core',
        description: 'Adapt Trafft completely to your specific booking needs',
        link: '/features/booking-core'
      },
      {
        title: 'Smart Calendar and Scheduling',
        description: 'Have a clear view of all your appointments in one calendar',
        link: '/features/smart-calendar-and-scheduling/'
      },
      {
        title: 'Flexible Scheduling',
        description: 'Create your schedules with complete flexibility',
        link: '/features/flexible-scheduling/'
      },
    ]
  },
  {
    name: 'Payment Automation',
    items: [
      {
        title: 'Payments Processing',
        description: 'Get paid for your services easily, safely and on time',
        link: '/features/payment-processing/'
      },
      {
        title: 'Invoicing and Tax Management',
        description: 'Manage invoices, taxes and payments automatically',
        link: '/features/invoicing-and-tax-management/'
      }
    ]
  },
  {
    name: 'Marketing and Sales',
    items: [
      {
        title: 'No-code Booking Page Creation',
        description: 'Promote your brand online with a customizable booking page',
        link: '/features/no-code-booking-page-creation/'
      },
      {
        title: 'Loyalty Boost',
        description: 'Automate and personalize the communication with customers',
        link: '/features/loyalty-boost/'
      },
      {
        title: 'Lead Capture',
        description: 'Turn your leads into customers with effective marketing',
        link: '/features/lead-capture/'
      },
      {
        title: 'Integrations',
        description: 'Use Trafft\'s integrations to connect Trafft with other tools',
        link: '/features/integrations/'
      }
    ]
  }
]

const industries = [
  {
    icon: Salons,
    title: 'Beauty Salons',
    link: '/beauty-salons/'
  },
  {
    icon: Barbershop,
    title: 'Barbershop',
    link: '/barbershop/'
  },
  {
    icon: Coaching,
    title: 'Coaching & Consulting',
    link: '/industries/coaching/'
  },
  {
    icon: Healthcare,
    title: 'Healthcare',
    link: '/healthcare/'
  },
  {
    icon: Education,
    title: 'Education & Teaching',
    link: '/education-consulting/'
  },
  {
    icon: PersonalServices,
    title: 'Personal Services',
    link: '/personal-services/'
  },
  {
    icon: Dental,
    title: 'Dental clinics',
    link: '/dental-clinic/'
  },
  {
    icon: GovernmentIcon,
    title: 'Government & Administration',
    link: '/administration-officials/'
  },
  {
    icon: HomeServicesIcon,
    title: 'Home services',
    link: '/home-services/'
  },
  {
    icon: Cleaning,
    title: 'Cleaning services',
    link: '/cleaning-services/'
  },
  {
    icon: AutomotiveServices,
    title: 'Automotive services',
    link: '/automotive-services/'
  },
  {
    icon: Sports,
    title: 'Fitness & Sports',
    link: '/fitness-and-sports/'
  }
]

const whiteLabelSolutions = [
  {
    icon: Agency,
    title: 'For Agencies ',
    link: '/white-label-booking-software/'
  }
]



const trafftUrl = process.env.GATSBY_WEBSITE_URL;
const resourcesItems = [
  {
    name: "Resources",
    items: [
      {
        icon: Blog,
        name: 'Trafft Blog',
        description: 'Check out the latest information on industry trends and get advice for running a service business online',
        link: trafftUrl + 'blog',
      },
      {
        icon: Docs,
        name: 'Guides and Documentation',
        description: 'Get a detailed explanation of how every Trafft feature and integration work',
        link: '/docs/',
      }
    ]
  }
];

const aboutUsItems = [
  {
    name: 'Our Story',
    link: '/about',
    internal: true,
    description: 'Read about Trafft’s story, mission and values we share'
  },
  {
    name: 'Affiliate Partners',
    link: '/affiliate',
    internal: true,
    description: 'Join us on our journey of helping service businesses thrive through automation'
  },
  {
    name: 'Partners',
    link: '/partners',
    internal: true,
    description: 'Partner with Trafft and expand your market reach'
  },
  {
    name: 'Investor Relations',
    link: '/investors',
    internal: true,
    description: 'Reach out to us if you are interested in investing in Trafft'
  },
  {
    name: 'Why Trafft',
    link: '/why-trafft',
    internal: true,
    description: 'Learn more about why you should choose Trafft'
  },
  {
    name: 'Contact us',
    link: '/contact',
    internal: true,
    description: 'Feel free to reach out if you have any questions or suggestions'
  }
];

export {platformFeatures, industries, aboutUsItems, resourcesItems, whiteLabelSolutions}